export default {
  linkForm: {
    title: "Contact Form",
    subtitle: "Please fill out the information below and we'll get back to you soon",
    firstName: "First Name",
    lastName: "Last Name", 
    workEmail: "Work Email Address",
    companyName: "Company Name",
    firstNamePlaceholder: "Enter your first name",
    lastNamePlaceholder: "Enter your last name",
    workEmailPlaceholder: "Enter your work email address",
    companyNamePlaceholder: "Enter your company name",
    submitButton: "Submit Form",
    submitting: "Submitting...",
    resetButton: "Reset Form",
    successMessage: "Form submitted successfully! We'll contact you soon.",
    errorMessage: "Please check if the form is filled correctly.",
    resetMessage: "Form has been reset",
    validation: {
      firstNameRequired: "Please enter your first name",
      firstNameLength: "First name should be between 1-50 characters",
      lastNameRequired: "Please enter your last name", 
      lastNameLength: "Last name should be between 1-50 characters",
      workEmailRequired: "Please enter your work email address",
      workEmailFormat: "Please enter a valid email format",
      companyNameRequired: "Please enter your company name",
      companyNameLength: "Company name should be between 1-100 characters"
    }
  }
};
